<template>
  <div class="w-full">
    <el-form :model="form" :label-position="labelPosition" :rules="rules" ref="form">
      <SupplyForm :form="form" />
      <el-form-item :gutter="20" class="px-5">
        <el-button type="primary" @click="submit('form')" :loading="adding">Continue</el-button>
        <el-button @click="$router.back()" type="info">Cancel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import SupplyForm from './_includes/SupplyForm.vue';

export default {
  name: 'NewSupply',
  data() {
    return {
      adding: false,
      labelPosition: 'top',
      rules: this.$store.state.InventoryModule.Supplies.supply_form_validation,
    };
  },
  components: {
    SupplyForm,
  },
  computed: {
    form() {
      return this.$store.state.InventoryModule.Supplies.new_supply;
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    submit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          try {
            this.adding = true;
            await this.$store.dispatch('InventoryModule/Supplies/newSupply', { supply: this.form });
            this.$notify.success({
              title: 'Success',
              message: 'Supply successfully added',
            });
            await this.$router.push(`/ecommerce/supply/goods/${
              this.$store.state.InventoryModule.Supplies.supply.id
            }/edit`);
          } catch (e) {
            this.adding = false;
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong',
            });
          }
          this.adding = false;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
